exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-section {\r\n    display: inline;\r\n    float: right;\r\n    margin: 10px 8px;\r\n    position: relative;\r\n}\r\n.search-section span {\r\n    font-size: 12px;\r\n}\r\n.search-section a {\r\n    color: #1D6798;\r\n    padding: 4px;\r\n    font-size: 12px;\r\n}\r\n#hederLogoTitle{\r\n    font-size: 20px;\r\n    color: #1D6798;\r\n    font-weight: bold;\r\n    display:inline-block\r\n}\r\n#logoImage{\r\n    margin-bottom: 10px;\r\n}\r\n.arabicLabel {\r\n    position: relative;\r\n    display: block;\r\n    text-decoration: none;\r\n    font-size: 12px;\r\n    direction: rtl;\r\n    margin-left: 45px\r\n}\r\n\r\n .headerParent {\r\n    margin-bottom: -8px;\r\n    margin-top: 20px;\r\n}\r\n.logo-section{\r\n    top: -14px;\r\n    display:inline;\r\n    height:45px;\r\n}\r\n.searchBar{\r\n    float: right;\r\n     margin-right: 20px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/shared/navigation/Navigation.css
// module id = 541
// module chunks = 3